import { matchPath } from "react-router";

import { PROJECT_COVER_TRANSITION_TYPE } from "@/navigation/constants/transition-types";
import { ROUTES } from "@/navigation/constants/routes";

const isProjectPage = (pathname: string) =>
  matchPath(ROUTES.catalog + "/:desktopProjectId", pathname) !== null;

/**
 * The transition types a navigation from one path to another carries.
 *
 * Every cover travels when a project page is on one end: opening an album
 * carries its cover in, and leaving it carries the cover back. Anywhere else
 * nothing does, the home page to the catalog included: a page both draw the
 * same albums on would otherwise fly every one of them across.
 */
export const resolveNavigationTransitionTypes = ({
  fromPathname,
  toPathname,
}: {
  fromPathname: string;
  toPathname: string;
}) => {
  if (isProjectPage(fromPathname) || isProjectPage(toPathname)) {
    return [PROJECT_COVER_TRANSITION_TYPE];
  }
  return [];
};
